import React, { useRef } from 'react';
import { Link, Switch, Route, useHistory, useParams, useLocation, useRouteMatch } from 'react-router-dom';
import { TabsContainer, TabItem } from 'quantux-ui';
import { gray, salmon, blue, theme } from '../../theme';
import PrimaryInsurance from './primary-insurance';
import SecondaryInsurance from './secondary-insurance';
import TertiaryInsurance from './tertiary-insurance';

const tabsTextStyles = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};

const piIcon = (
  <svg
    width="18"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.5 2.857 9.071 0l8.572 2.857v8.572A8.57 8.57 0 0 1 9.07 20 8.57 8.57 0 0 1 .5 11.429V2.857Zm8.574 15.536a6.965 6.965 0 0 0 6.964-6.964V4.063L9.074 1.607 2.109 4.063v7.366a6.965 6.965 0 0 0 6.965 6.964Zm1.101-5.318V14h-4v-.925H7.64V8.86c0-.167.005-.338.015-.515l-1.04.87a.457.457 0 0 1-.18.09.457.457 0 0 1-.3-.05.318.318 0 0 1-.09-.085l-.39-.535L7.86 6.76h1.015v6.315h1.3Zm2.957-8.095a2.222 2.222 0 0 0-.828-.148c-.307 0-.585.05-.836.148-.25.099-.465.239-.644.42a1.906 1.906 0 0 0-.412.664 2.526 2.526 0 0 0-.144.876c0 .325.048.619.144.88.099.261.236.484.412.668.179.184.393.325.644.424.25.099.53.148.836.148.304 0 .58-.05.828-.148.25-.099.464-.24.64-.424a1.87 1.87 0 0 0 .412-.668c.096-.261.144-.555.144-.88 0-.323-.048-.615-.144-.876a1.794 1.794 0 0 0-1.052-1.084Zm-.072 2.976c-.163.23-.415.344-.756.344-.347 0-.604-.115-.772-.344-.165-.232-.248-.568-.248-1.008 0-.44.083-.776.248-1.008.168-.235.425-.352.772-.352.341 0 .593.116.756.348.165.232.248.57.248 1.012 0 .443-.083.779-.248 1.008Z"
      fill="#00A0FF"
    />
  </svg>
);

const siIcon = (
  <svg
    width="18"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.5 2.857 9.071 0l8.572 2.857v8.572A8.57 8.57 0 0 1 9.07 20 8.57 8.57 0 0 1 .5 11.429V2.857Zm8.574 15.536a6.965 6.965 0 0 0 6.964-6.964V4.063L9.074 1.607 2.109 4.063v7.366a6.965 6.965 0 0 0 6.965 6.964Zm.831-5.543c.133 0 .238.038.315.115a.38.38 0 0 1 .12.295V14H5.38v-.41a.696.696 0 0 1 .22-.51l2.195-2.2c.183-.187.347-.365.49-.535.147-.17.268-.338.365-.505a2.3 2.3 0 0 0 .22-.505c.053-.173.08-.355.08-.545 0-.173-.025-.325-.075-.455A.893.893 0 0 0 8.66 8a.83.83 0 0 0-.33-.2 1.238 1.238 0 0 0-.43-.07c-.147 0-.283.022-.41.065-.123.04-.233.098-.33.175-.097.073-.178.16-.245.26s-.117.21-.15.33c-.057.153-.13.255-.22.305-.09.05-.22.062-.39.035l-.65-.115c.05-.347.147-.65.29-.91.143-.263.322-.482.535-.655.217-.177.463-.308.74-.395.28-.09.58-.135.9-.135.333 0 .638.05.915.15.277.097.513.235.71.415.197.18.35.397.46.65a2.1 2.1 0 0 1 .165.845c0 .267-.04.513-.12.74a2.925 2.925 0 0 1-.315.65c-.13.207-.283.407-.46.6-.177.193-.362.39-.555.59l-1.63 1.665c.157-.047.312-.082.465-.105.157-.027.305-.04.445-.04h1.855Zm3.227-7.87a2.222 2.222 0 0 0-.828-.148c-.307 0-.585.05-.836.148-.25.099-.465.239-.644.42a1.906 1.906 0 0 0-.412.664 2.526 2.526 0 0 0-.144.876c0 .325.048.619.144.88.099.261.236.484.412.668.179.184.393.325.644.424.25.099.53.148.836.148.304 0 .58-.05.828-.148.25-.099.464-.24.64-.424a1.87 1.87 0 0 0 .412-.668c.096-.261.144-.555.144-.88 0-.323-.048-.615-.144-.876a1.794 1.794 0 0 0-1.052-1.084Zm-.072 2.976c-.163.23-.415.344-.756.344-.347 0-.604-.115-.772-.344-.165-.232-.248-.568-.248-1.008 0-.44.083-.776.248-1.008.168-.235.425-.352.772-.352.341 0 .593.116.756.348.165.232.248.57.248 1.012 0 .443-.083.779-.248 1.008Z"
      fill="#9CF"
    />
  </svg>
);

const tiIcon = (
  <svg
    width="18"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.5 2.857 9.071 0l8.572 2.857v8.572A8.57 8.57 0 0 1 9.07 20 8.57 8.57 0 0 1 .5 11.429V2.857Zm8.574 15.536a6.965 6.965 0 0 0 6.964-6.964V4.063L9.074 1.607 2.109 4.063v7.366a6.965 6.965 0 0 0 6.965 6.964ZM5.54 8.785c.05-.347.147-.65.29-.91.143-.263.322-.482.535-.655.217-.177.463-.308.74-.395.28-.09.58-.135.9-.135.333 0 .633.048.9.145a2 2 0 0 1 .69.395 1.751 1.751 0 0 1 .59 1.325c0 .23-.027.433-.08.61a1.314 1.314 0 0 1-.58.785 2.24 2.24 0 0 1-.485.225c.433.137.757.345.97.625.213.28.32.632.32 1.055 0 .36-.067.678-.2.955-.133.277-.313.51-.54.7-.227.187-.49.328-.79.425a3.03 3.03 0 0 1-.945.145c-.363 0-.68-.042-.95-.125a2.063 2.063 0 0 1-.705-.37c-.2-.163-.37-.363-.51-.6a4.05 4.05 0 0 1-.36-.82l.545-.225a.634.634 0 0 1 .4-.045.384.384 0 0 1 .275.2c.06.117.125.232.195.345.073.113.16.215.26.305.1.087.217.158.35.215.137.053.298.08.485.08.21 0 .393-.033.55-.1.157-.07.287-.16.39-.27a1.12 1.12 0 0 0 .315-.775c0-.173-.018-.33-.055-.47a.7.7 0 0 0-.23-.365 1.251 1.251 0 0 0-.505-.235c-.217-.057-.508-.085-.875-.085v-.88c.303-.003.555-.032.755-.085.2-.053.358-.127.475-.22a.763.763 0 0 0 .25-.345c.047-.133.07-.28.07-.44 0-.34-.095-.598-.285-.775-.19-.177-.443-.265-.76-.265a1.214 1.214 0 0 0-.74.24c-.097.073-.178.16-.245.26s-.117.21-.15.33c-.057.153-.132.255-.225.305-.09.05-.218.062-.385.035l-.65-.115Zm7.592-3.805a2.222 2.222 0 0 0-.828-.148c-.307 0-.585.05-.836.148-.25.099-.465.239-.644.42a1.906 1.906 0 0 0-.412.664 2.526 2.526 0 0 0-.144.876c0 .325.048.619.144.88.099.261.236.484.412.668.179.184.393.325.644.424.25.099.53.148.836.148.304 0 .58-.05.828-.148.25-.099.464-.24.64-.424a1.87 1.87 0 0 0 .412-.668c.096-.261.144-.555.144-.88 0-.323-.048-.615-.144-.876a1.794 1.794 0 0 0-1.052-1.084Zm-.072 2.976c-.163.23-.415.344-.756.344-.347 0-.604-.115-.772-.344-.165-.232-.248-.568-.248-1.008 0-.44.083-.776.248-1.008.168-.235.425-.352.772-.352.341 0 .593.116.756.348.165.232.248.57.248 1.012 0 .443-.083.779-.248 1.008Z"
      fill="#9CF"
    />
  </svg>
);

const selfPayIcon = (
  <svg
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 0a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm12.063 5.938a3.745 3.745 0 0 1-3.75 3.75 3.745 3.745 0 0 1-3.75-3.75 3.745 3.745 0 0 1 3.75-3.75 3.745 3.745 0 0 1 3.75 3.75Zm-11.25 10c0-2.5 5-3.876 7.5-3.876s7.5 1.376 7.5 3.876v1.25h-15v-1.25Z"
      fill="#96C8FF"
    />
  </svg>
);

const flagIcon = (
  <svg
    width="16"
    height="16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.997 0H0v16h16V0h-.003Zm0 0v16l-5.622-8 5.622-8Z" fill="#FF6060"
    />
  </svg>
);

// #region Temporary Components
const SelfPay = () => (
  <div className='p-4'>
    <h1>Self Pay Placeholder</h1>
  </div>
);
// #endregion

const PatientInsurance = (props) => {
  // Refs
  const mainTabsContainer = useRef();

  // Router related
  const history = useHistory();
  const location = useLocation();
  const { pathname } = location;
  const { path, url } = useRouteMatch();

  const {
    drawerBackground,
    drawerBorderColor,
    drawerTextColor,
    drawerFontSize,
    drawerFontWeight,
    // Drawer Tabs
    tabBackground,
    tabActiveBackground,
    tabHoverBackground,
    tabIndicatorBackground,
    tabIndicatorHoverBackground,
    tabIndicatorActiveBackground,
    tabTextColor,
    tabHoverTextColor,
    tabActiveTextColor,
    tabFontSize,
    tabFontWeight,
    groupSeparators,
    headerBackground,
    headerTextColor,
    headerFontSize,
    headerFontWeight,
    groupHeaderTextColor,
    groupHeaderTextOpacity,
    groupHeaderFontSize,
    groupHeaderFontWeight,
    groupTabIndent
  } = theme.splitPanelDrawer;

  return (
    <div
      ref={mainTabsContainer}
      style={{
        height: '100%',
        flexGrow: '1',
        flexShrink: '1',
        display: 'flex',
        flexFlow: 'column',
        overflowY: 'hidden',
        paddingLeft: '8px'
      }}
    >
      <TabsContainer
        dropDownId="d1"
        showPlusIcon={false}
        isDrawer={false}
        shiftMethod='availableWidth'
        containerWidth={mainTabsContainer && mainTabsContainer.current ? mainTabsContainer.current.getBoundingClientRect().width : 610}
        otherElementsWidth={320}
        minWidth={610}
        dropDownTop={39}
        dropDownLeft={44}
        containerStyles={{ width: '100%' }}
      >
        {/* Primary Insurance */}
        <TabItem
          key='primary_insurance_tab'
          tabKey="1"
          parentKey="0555"
          text="Primary Insurance"
          isActive={pathname.endsWith('/primary')}
          showSvgIcon
          svgIcon={props.piFlag ? flagIcon : piIcon}
          style={{
            width: '160px',
            minWidth: '160px',
            maxWidth: '160px'
          }}
          textStyles={tabsTextStyles}
          onActivate={() => {
            history.push(`${url}/primary`);
            console.log('Primary Insurance Tab!');
          }}
        >
          <Link to={`${url}/info`}>Primary Insurance</Link>
        </TabItem>
        {/* Secondary Insurance */}
        <TabItem
          key='secondary_insurance_tab'
          tabKey="2"
          parentKey="0666"
          text="Secondary Insurance"
          isActive={pathname.endsWith('/secondary')}
          showSvgIcon
          svgIcon={props.siFlag ? flagIcon : siIcon}
          style={{
            width: '175px',
            minWidth: '175px',
            maxWidth: '175px'
          }}
          textStyles={tabsTextStyles}
          onActivate={() => {
            history.push(`${url}/secondary`);
            console.log('Loading secondary insurance');
          }}
        >
          <Link to={`${url}/id`}>Secondary Insurance</Link>
        </TabItem>
        {/* Tertiary Insurance */}
        <TabItem
          key='tertirary_insurance_tab'
          tabKey="3"
          parentKey="0777"
          text="Tertiary Insurance"
          isActive={pathname.endsWith('/tertiary')}
          showSvgIcon
          svgIcon={props.tiFlag ? flagIcon : tiIcon}
          style={{
            width: '160px',
            minWidth: '160px',
            maxWidth: '160px'
          }}
          textStyles={tabsTextStyles}
          onActivate={() => {
            history.push(`${url}/tertiary`);
            console.log('Loading Tertiary Insurance');
          }}
        >
          <Link to={`${url}/insurance`}>
            Tertiary Insurance
          </Link>
        </TabItem>
        {/* Self Pay */}
        <TabItem
          key='self_pay_tab'
          tabKey="4"
          parentKey="0888"
          text="Self Pay"
          isActive={pathname.endsWith('/selfpay')}
          showSvgIcon
          svgIcon={selfPayIcon}
          style={{
            width: '90px',
            minWidth: '90px',
            maxWidth: '90px'
          }}
          textStyles={tabsTextStyles}
          onActivate={() => {
            history.push(`${url}/selfpay`);
            console.log('Loading self pay tab');
          }}
        >
          <Link to={`${url}/contact`}>
            Self Pay
          </Link>
        </TabItem>
      </TabsContainer>
      {/* Active Tab  */}
      <div style={{ height: '100%' }}>
        <Switch>
          <Route exact path={`${path}`}>
            <PrimaryInsurance
              patientData={props.patientData}
              updateFlag={props.updateFlag}
            />
          </Route>
          <Route path={`${path}/primary`}>
            <PrimaryInsurance
              patientData={props.patientData}
              updateFlag={props.updateFlag}
            />
          </Route>
          <Route path={`${path}/secondary`}>
            <SecondaryInsurance
              patientData={props.patientData}
              updateFlag={props.updateFlag}
            />
          </Route>
          <Route path={`${path}/tertiary`}>
            <TertiaryInsurance
               patientData={props.patientData}
               updateFlag={props.updateFlag}
            />
          </Route>
          <Route path={`${path}/selfpay`}>
            <SelfPay />
          </Route>
        </Switch>
      </div>
    </div>
  );
};

PatientInsurance.defaultProps = {
  patientData: {}
};

export default PatientInsurance;
